<template>
    <div class="my-profile">
        <mt-header fixed title="我的资料">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="elder-form">

            <mt-field label="联系电话" placeholder="请输入联系电话"  v-model="phone"></mt-field>
            <mint-select selectLabel="学历" selectPatch="education" :selectValue="education" :slots="educationSlots" @changeValue="changeValue"></mint-select>
            <mt-field label="专业" placeholder="请输入专业"  v-model="major"></mt-field>
            <mt-field label="学位" placeholder="请输入学位"  v-model="degree"></mt-field>
            <mt-field label="入职时间" placeholder="请输入入职时间" type="date" v-model="enter_time"></mt-field>

            <div class="mint-checklist">
                <label class="mint-checklist-title">工作证件照</label>
                <div class="worker-photo" v-if="worker_photo_exist">
                    <img :src="worker_photo_url" class="worker-photo-img">
                </div>
                <uploader @getFiles='getImageList' @removeFiles='removeImage'></uploader>
            </div>

            <mt-field label="登录密码" placeholder="请输入登录密码" type="password" v-model="password"></mt-field>
            <mt-field label="重复登录密码" placeholder="请重复登录密码" type="password" v-model="rpassword"></mt-field>
            <div class="new-form-button">
                <mt-button size="large" type="primary" @click="updateProfile">提交</mt-button>
            </div>
        </div>
    </div>
</template>
<style>
    .worker-photo{
        padding:10px;
    }
    .worker-photo-img{
        width:100%;
        height:200px;
    }
</style>
<script>
    import mintSelect from '../../components/mintSelect.vue'
    import uploader from "../../components/upload"
    import GlOBAL from "@/api/global"

    export default{

        components: {
            'mint-select':mintSelect,
            'uploader':  uploader
        },

        data(){
           return {
               userInfo:JSON.parse(window.localStorage.getItem('UserInfo')),

               phone:'',
               password:'',
               rpassword:'',
               education:'',
               degree:'',
               major:'',
               enter_time:'',
               worker_photo_exist:false,
               worker_photo_url:'',

               educationSlots: [
                   {
                       values: ['','本科','研究生','大专','中专','高中','初中'],
                       className: 'slot1',
                       textAlign: 'center'
                   }
               ],


               imgUrl:GlOBAL.imgUrl,
               imgList: [], //已上传的图片集合
           }
        },
        methods:{
            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },

            updateProfile(){

                if(this.imgList.length>0){
                   this.worker_photo_exist = false;
                }

                if(this.imgList.length>1){
                    this.$toast('工作证件照仅支持上传1张！');
                    return false;
                }

                if(this.password!==this.rpassword){
                    this.$toast('两次密码不一致！');
                    return false;
                }

                this.$indicator.open('加载中');

                console.log(this.worker_photo_exist);

                this.$axios.post("/my/profile", {openid:this.userInfo.openid,phone:this.phone,password:this.password,education:this.education,degree:this.degree,major:this.major,enter_time:this.enter_time,worker_photo:this.imgList,worker_photo_exist:this.worker_photo_exist})
                    .then(data => {

                        this.$indicator.close();

                        if (data.data.code === 'OK') {
                            this.userInfo.phone = data.data.data.phone;
                            localStorage.setItem('UserInfo',JSON.stringify(this.userInfo));
                            this.$toast('修改成功!');
                        } else {
                            this.$toast(data.data.message);
                        }
                    });

            },

            getImageList(files) {
                this.$nextTick(() => {

                    for (let i = 0, len = files.length; i < len; i++) {

                        this.imgList.push(files[i].src.split("base64,")[1]);
                        //上传图片
                        //   this._getFileCode({
                        //     Base64Str: files[i].src.split("base64,")[1],
                        //     AttachmentType: this.$enums.AttachmentType.Activity
                        //   });
                    }
                });
            },
            //删除图片
            removeImage(index) {
                this.imgList.splice(index, 1);
            },

            //上传图片获取fileCode (目前该方法没调用，供参考)
            _getFileCode(obj) {
                // Indicator.open(this.lang.dynamic_publishing);
                this.$http
                    .post(this.$profileApi.Shared_UploadImage, obj)
                    .then(data => {
                        if (data.Rstatus) {
                            this.FilecodeList.push(data.Rdata);
                        } else {
                            // Toast(this.lang.dynamic_upload_fail);
                        }
                    })
                    .catch(err => {
                        //   Toast(this.lang.dynamic.dynamic_net_error);
                    });
            },

        },

        created(){
            this.$axios.get('/my/profile?openid='+this.userInfo.openid)
                .then(data => {

                    if (data.data.code === 'OK') {
                        let r = data.data.data;
                        this.phone = r.phone;
                        this.education = r.education;
                        this.degree = r.degree;
                        this.major = r.major;
                        this.enter_time = r.enter_time;

                        if(r.worker_photo!==''&&r.worker_photo!==null){
                            this.worker_photo_exist = true;
                            this.worker_photo_url = this.imgUrl+'uploads/'+r.worker_photo;

                        }

                    } else {
                        this.$toast(data.data.message);
                    }
                });

        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/my/profile.vue